import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿El contenido es digital?',
    a: 'Sí. Todo el Mega Pack y sus bonos se descargan en formato PDF de alta calidad.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Luego de comprar accedés automáticamente a la descarga directa a tu correo y pantalla.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida. Podés descargarlo hoy y usarlo cuando quieras.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Es 100% compatible con celular, tablet y PC. Podés llevar los planos al taller en tu teléfono.'
  }, {
    q: '¿Los planos traen medidas exactas?',
    a: 'Sí, todos los diseños premium vienen con proporciones y medidas referenciales listas para adaptar a tus proyectos.'
  }, {
    q: '¿Sirve si recién empiezo en la herrería?',
    a: 'Totalmente. Tener diseños claros y modernos te va a ayudar a empezar ofreciendo trabajos de alta calidad desde el día uno.'
  }, {
    q: '¿Qué tipo de materiales se usan en los diseños?',
    a: 'Los planos están pensados para herrería moderna: caños estructurales, hierro, combinaciones con madera y chapa plegada.'
  }, {
    q: '¿Puedo imprimir los planos?',
    a: 'Sí, los archivos PDF están optimizados para que puedas imprimirlos y tenerlos en papel en tu mesa de trabajo.'
  }, {
    q: '¿Qué pasa si tengo dudas con la compra?',
    a: 'Contamos con soporte por correo electrónico para ayudarte con cualquier inconveniente en el acceso a tu material.'
  }, {
    q: '¿Cuáles son los medios de pago?',
    a: 'Aceptamos Mercado Pago, tarjetas de crédito/débito, transferencias y efectivo en redes de cobranza. Todo 100% seguro.'
  }];
  return <section className="py-8 md:py-14 px-3 bg-brand-dark" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <h2 className="text-xl md:text-4xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-38">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-lg border ${openIndex === index ? 'border-brand-accent' : 'border-white/5'} overflow-hidden transition-all duration-300`} data-id="element-40">
              <button className="w-full px-3 py-3 md:px-5 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-41">
                <span className={`font-black text-xs md:text-base pr-3 ${openIndex === index ? 'text-brand-accent' : 'text-white'}`} data-id="element-42">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-4 h-4 md:w-5 md:h-5 text-brand-accent shrink-0" data-id="element-43" /> : <ChevronDown className="w-4 h-4 md:w-5 md:h-5 text-gray-500 shrink-0" data-id="element-44" />}
              </button>

              <div className={`px-3 md:px-5 overflow-hidden transition-all duration-300 ease-in-out bg-[#0f0f0f] ${openIndex === index ? 'max-h-96 py-3 opacity-100 border-t border-white/10' : 'max-h-0 opacity-0'}`} data-id="element-45">
                <p className="text-xs md:text-sm text-gray-300 leading-relaxed font-medium" data-id="element-46">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}